import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
} from '@mui/material';

export default function SendNotificationDialog({ open, onClose }) {
  const [channel, setChannel] = useState('all-teachers');
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [targetId, setTargetId] = useState('');
  const [targets, setTargets] = useState({ teachers: [], parents: [] });
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (open) {
      fetch('/api/admin/notification-users', { credentials: 'include' })
        .then((res) => res.json())
        .then((data) => {
          setTargets(data);
        });
    }
  }, [open]);

  const handleSend = async () => {
    setStatus(null);
    try {
      // setLoading(true); // Define loading state if needed
      const res = await fetch('/api/admin/notifications/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          channel,
          targetId: channel.startsWith('specific') ? targetId : undefined,
          type: 'info', // Assuming type is defined or passed in, defaulting to 'info'
          title,
          message,
        }),
        credentials: 'include',
      });
      if (res.ok) {
        setStatus({ type: 'success', msg: 'Notification sent!' });
        setTimeout(() => {
          onClose();
          setTitle('');
          setMessage('');
          setStatus(null);
        }, 1500);
      } else {
        const data = await res.json();
        setStatus({ type: 'error', msg: data.message || 'Failed to send' });
      }
    } catch (err) {
      setStatus({ type: 'error', msg: 'Network error' });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Send Notification</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}
      >
        {status && <Alert severity={status.type}>{status.msg}</Alert>}
        <FormControl fullWidth>
          <InputLabel>Channel</InputLabel>
          <Select
            value={channel}
            label="Channel"
            onChange={(e) => setChannel(e.target.value)}
          >
            <MenuItem value="all-teachers">All Teachers</MenuItem>
            <MenuItem value="all-parents">All Parents</MenuItem>
            <MenuItem value="specific-teacher">Specific Teacher</MenuItem>
            <MenuItem value="specific-parent">Specific Parent</MenuItem>
          </Select>
        </FormControl>

        {channel === 'specific-teacher' && (
          <FormControl fullWidth>
            <InputLabel>Select Teacher</InputLabel>
            <Select
              value={targetId}
              label="Select Teacher"
              onChange={(e) => setTargetId(e.target.value)}
            >
              {targets.teachers.map((t) => (
                <MenuItem key={t._id} value={t._id}>
                  {t.username}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {channel === 'specific-parent' && (
          <FormControl fullWidth>
            <InputLabel>Select Parent</InputLabel>
            <Select
              value={targetId}
              label="Select Parent"
              onChange={(e) => setTargetId(e.target.value)}
            >
              {targets.parents.map((p) => (
                <MenuItem key={p._id} value={p._id}>
                  {p.username}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <TextField
          label="Title"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          label="Message"
          fullWidth
          multiline
          rows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSend}>
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
